import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "@/i18n";

export const StatusBadge = ({ status, testId }) => {
  const { t } = useI18n();
  return <span data-testid={testId} className="bg-[#12204A] px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.12em] text-[var(--gold)]">{t.catalog.status[status] || status}</span>;
};

export const CategoryCard = ({ category, index }) => {
  const { t } = useI18n();
  return (
    <Link to={`/equipements/${category.slug}`} data-testid={`category-card-${category.slug}`} className="group relative min-w-0 overflow-hidden border border-white/10 bg-[#0D1428]">
      <div className="aspect-[4/3] overflow-hidden bg-[#12204A]">
        <img src={category.image_url} alt={category.image_label} loading="lazy" className="h-full w-full object-cover opacity-75 transition-[transform,opacity] duration-500 group-hover:scale-[1.03] group-hover:opacity-95" />
      </div>
      <div className="p-5">
        <p className="font-mono text-[10px] tracking-[0.2em] text-[var(--gold)]">{String(index + 1).padStart(2, "0")}</p>
        <h3 className="font-display mt-3 text-2xl font-bold uppercase text-white">{category.name}</h3>
        <p className="mt-3 text-sm leading-relaxed text-[var(--steel-dim)]">{category.description}</p>
        <span className="mt-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.12em] text-white">{t.catalog.explore}<ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
      </div>
    </Link>
  );
};

export const ProductCard = ({ product }) => {
  const { t } = useI18n();
  const to = product.existing_mb300 ? "/#mb300" : `/equipements/${product.category_slug}/${product.slug}`;
  return (
    <article data-testid={`product-card-${product.reference}`} className="flex min-w-0 flex-col border border-white/10 bg-[#0D1428]">
      <Link to={to} data-testid={`product-image-link-${product.reference}`} className="block aspect-[4/3] overflow-hidden bg-[#12204A]">
        <img src={product.image_url} alt={product.image_label} loading="lazy" className="h-full w-full object-cover opacity-80 transition-[transform,opacity] duration-500 hover:scale-[1.03] hover:opacity-100" />
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <div className="flex flex-wrap items-center justify-between gap-2"><span className="font-mono text-[10px] text-[var(--steel-dim)]">{product.reference}</span><StatusBadge status={product.status} testId={`product-status-${product.reference}`} /></div>
        <h3 className="font-display mt-4 text-2xl font-bold uppercase">{product.name}</h3>
        <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-[var(--steel-dim)]">{product.description}</p>
        <Link to={to} data-testid={`product-detail-${product.reference}`} className="mt-6 inline-flex items-center gap-2 border-b border-[var(--gold)] pb-1 text-xs font-bold uppercase tracking-[0.12em] text-white self-start">{product.existing_mb300 ? t.catalog.mb300Details : t.catalog.viewProduct}<ArrowUpRight className="h-4 w-4" /></Link>
      </div>
    </article>
  );
};